let applicationDomainName = process.env.REACT_APP_APPLICATION_DOMAIN;

/** @class */
export class CustomStorage {
    /**
     * This is used to set a specific item in storage
     */
    static setItem(key, value) {
        let domainName = applicationDomainName;
        let date = new Date();
        date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
        let expires = "expires=" + date.toUTCString();

        if (key.includes('refreshToken') || key.includes('LastAuthUser')) {
            document.cookie = key + "=" + value + "; " + expires + "; domain=" + domainName + "; path=/";
        } else {
            // if (key.includes("refreshToken")) {
            //     let [header, payload, signature] = value.split(".");
            //     let headerAndPayload = header + '.' + payload;

            //     localStorage.setItem(key, headerAndPayload);
            //     document.cookie = key + "=" + signature + "; " + expires + "; domain=" + domainName + "; path=/";
            // } else {
            localStorage.setItem(key, value);
            // }
        }
    }

    /**
     * This is used to get a specific key from storage
     */
    static getItem(key) {
        let value = '';

        if (key.includes("idToken") || key.includes('refreshToken') || key.includes('LastAuthUser')) {
            value = this.readCookieByKeyName(key);
        } else {
            value = localStorage.getItem(key);
        }

        return value;
    }

    /**
     * This is used to remove an item from storage
     */
    static removeItem(key) {

    }

    /**
     * This is used to clear the storage
     */
    static clear() {

    }


    static readCookieByKeyName(key) {
        let value = '';
        document.cookie.split(';').forEach((e) => {
            if (e.includes(key)) {
                value = e.split('=')[1]
            }
        });

        return value;
    }
}
